import { ITechAnalytics } from "../types";
import { technicalAnalysis } from "@/services/tipRanks/technicalAnalysis";

export const technicalAnalysisApi = {
    getAllTickers: async (): Promise<ITechAnalytics | []> => {
        return await technicalAnalysis.getAllTickers();
    },

    getTechnicalAnalysisData: async ({
        ticker,
        timeFrame,
    }: {
        ticker: string;
        timeFrame: string;
    }): Promise<any> => {
        return await technicalAnalysis.getTechnicalAnalysisData({ ticker, timeFrame });
    },
};
